/**
 * Canonical WhatsApp JIDs for comparisons (matches edge normalization: @c.us → @s.whatsapp.net, bare digits).
 */
export function normalizeWhatsAppJid(jid: string | null | undefined): string {
  if (jid == null || jid === '') return ''
  const t = jid.trim()
  if (!t) return ''
  if (!t.includes('@')) {
    const digits = t.replace(/\D/g, '')
    if (/^\d+$/.test(digits)) return `${digits}@s.whatsapp.net`
    return t
  }
  const at = t.indexOf('@')
  const user = t.slice(0, at)
  const host = t.slice(at + 1).toLowerCase()
  if (host === 'c.us') return `${user}@s.whatsapp.net`
  return `${user}@${host}`
}

export function jidEquals(a: string | null | undefined, b: string | null | undefined): boolean {
  return normalizeWhatsAppJid(a) === normalizeWhatsAppJid(b)
}

export function messageBelongsToContact(
  msg: { remote_jid: string; account_contact_id?: string | null },
  contact: { id: string; jid: string; lid?: string | null }
): boolean {
  const cid = msg.account_contact_id
  if (cid != null && cid !== '' && cid === contact.id) return true

  // A mensagem pode ainda apontar para um contato duplicado antigo enquanto
  // remote_jid já foi normalizado, ou chegar pelo LID usado pelo WhatsApp.
  // Por isso, um ID diferente não deve impedir os fallbacks por JID/LID.
  if (jidEquals(msg.remote_jid, contact.jid)) return true
  return Boolean(contact.lid && jidEquals(msg.remote_jid, contact.lid))
}
